import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from 'src/app/store.service';
import {
  ModalDismissReasons,
  NgbDate,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { UtilitiesService } from 'src/app/core/utilities.service';
import {
  CART,
  ORDER_TYPE,
  PLATFORM,
  SOURCE,
} from 'src/app/core/constants/data.constant';

@Component({
  selector: 'app-abandoned-carts',
  templateUrl: './abandoned-carts.component.html',
  styleUrls: ['./abandoned-carts.component.scss'],
})
export class AbandonedCartsComponent implements OnInit {
  @Input() embedded = false;
  bearer;
  store_id;
  carts = [];
  expanded = [];
  allCarts = [];
  listData = [];
  page = 1;
  selectedPage = 20;
  start = 0;
  end = 0;
  dataIsLoading = true;
  email = '';
  storeId;
  id;
  is_openApi = '';
  orderType;
  orderTypeData = ['View All', 'Website', 'Open API'];
  filteredOrderType: string = '';

  orderId;
  pageSize = 20;
  statusFilters = [];
  orderPaginationList;

  closeResult = '';
  selectedcarts: any;

  minDate;
  maxDate;
  startDate;
  endDate;
  currentDate;
  day;
  month;
  year;
  myDate = new Date();
  date = {
    type: null,
    yesterday: [],
    today: [],
    cm: [],
    lm: [],
    cy: [],
    raw: [],
  };
  formattedDate = '';
  exportType = [{ display: 'Csv', value: 'csv' }];

  // loading = true;

  DATE_FILTERS = [
    { display: 'Today', value: 'today', range: false, selectable: false },
    { display: 'Yesterday', value: 'yesterday', range: false, selectable: false },
    { display: 'Current Month', value: 'cm', range: false, selectable: false },
    { display: 'Last Month', value: 'lm', range: false, selectable: false },
    { display: 'Last 30 Days', value: 'last30', range: false, selectable: false },
  ];

  filteredString: string = '';

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  dateFilter: any;
  orderTypeFilters = [];
  cartStatusFilters = [];
  platformTypeFilters = [];
  selectedOrderType;
  selectedPlatformType;
  selectedStatus;
  storeCartsData = [];
  searchCarts;
  searchCartsData;
  finalList = [];

  filterTable = [
    {
      filterName: 'selectedOrderType',
      filterCallback: (orderData, filterValue) => {
        if (filterValue === 'normal') {
          return ![2, 3, 4, 5, 7].includes(+orderData.order_type);
        } else if (filterValue === 'express_checkout') {
          return +orderData.order_type === 2;
        } else if (filterValue === 'aemis') {
          return +orderData.order_type === 3;
        } else if (filterValue === 'subscription') {
          return +orderData.order_type === 4;
        } else if (filterValue === 'pre_order') {
          return +orderData.order_type === 5;
        } else if (filterValue === 'repurchase') {
          return +orderData.order_type === 7;
        }
        return false;
      },
    },
    {
      filterName: 'selectedPlatformType',
      filterCallback: (orderData, filterValue) =>
        orderData?.platform === filterValue,
    },
    {
      filterName: 'selectedStatus',
      filterCallback: (orderData, filterValue) => {
        if (filterValue === 'pending') {
          return +orderData.status_id === 0;
        } else if (filterValue === 'resolved') {
          return +orderData.status_id === 2;
        } else if (filterValue === 'discarded') {
          return +orderData.status_id === 8;
        }
        return false;
      },
    },
  ];

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private router: Router,
    public utils: UtilitiesService
  ) {
    this.dateFilter = this.DATE_FILTERS[2];
  }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    this.day = this.myDate.getDate();
    this.month = this.myDate.getMonth(); // Be careful! January is 0, not 1
    this.year = this.myDate.getFullYear();
    this.currentDate = this.year + '-' + (this.month + 1) + '-' + this.day;
    this.startDate = this.year + '-' + (this.month + 1) + '-01';
    this.endDate = this.currentDate;
    this.minDate = { year: 2021, month: 1, day: 1 };
    this.maxDate = { year: this.year, month: this.month + 1, day: this.day };

    this.datePeriod();
  }

  getAbandonedCarts() {
    this.orderId = '';
    this.dataIsLoading = true;
    this.formattedDate = this.startDate + ',' + this.endDate;
    //change format for this.date to get start and end
    this.svc
      .getAbandonedCarts(
        this.bearer,
        this.store_id,
        this.email,
        this.formattedDate,
        this.page,
        0
      )
      .subscribe(
        (res) => {
          this.allCarts = res['data'];
          this.storeCartsData = res['data'];
          this.searchCarts = res['data'];
          if (this.allCarts && this.allCarts.length > 0) {
            this.allCarts.forEach((value, index) => {
              this.expanded[index] = false;
            });
          }

          this.orderTypeFilters = SOURCE;
          this.cartStatusFilters = CART;

          const platformFilters = [
            'ALL',
            ...[...new Set(this.allCarts.map((item) => item.platform))].sort(),
          ];
          this.platformTypeFilters = platformFilters.map((item) => ({
            display: this.getPlatformType(item)?.display,
            value: item,
          }));
          this.dataIsLoading = false;
        },
        (error) => {
          this.dataIsLoading = false;
        }
      );
  }

  changePage(pageOfItems) {
    this.page = pageOfItems;
    this.sliceRecord(this.allCarts);
  }

  searchEmail(event) {
    this.email = event.target.value?.toString()?.toLowerCase();
    this.page = 1;
    this.search();

    // this.searchCarts = event.target.value.toString().toLowerCase();
    // console.log('searchCarts', this.searchCarts);
    // if (this.searchCarts !== undefined && this.searchCarts !== '') {
    //   this.email = this.searchCarts;
    //   this.allCarts = this.storeCartsData?.filter((checkout) =>
    //     checkout.customer_email
    //       .toLowerCase()
    //       .startsWith(this.searchCarts.toString().toLowerCase())
    //   );
    // } else {
    //   this.email = '';
    //   this.allCarts = this.storeCartsData;
    // }
  }

  openModal(content, index) {
    this.selectedcarts = this.allCarts[index];
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        windowClass: 'modal-order-details-container',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${AbandonedCartsComponent.getDismissReason(
            reason
          )}`;
        }
      );
  }

  watchSession() {
    this.openSessionReplay(
      this.selectedcarts?.visitor_id,
      this.selectedcarts?.session_id
    );
  }

  watchSessionFromList(data) {
    this.openSessionReplay(data?.visitor_id, data?.session_id);
  }

  private openSessionReplay(visitorId: string, sessionId: string) {
    if (!sessionId) return;
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/dashboard/replay', visitorId, sessionId])
    );
    window.open(url, '_blank');
  }

  openLink(openlink, data) {
    this.listData = data;
    this.modalService
      .open(openlink, {
        size: 'lg',
        backdrop: 'static',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${AbandonedCartsComponent.getDismissReason(
            reason
          )}`;
        }
      );
  }

  open(content, id) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          if (result == 'delete') {
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${AbandonedCartsComponent.getDismissReason(
            reason
          )}`;
        }
      );
  }

  private static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  clearDateRange() {
    this.fromDate = null;
    this.toDate = null;
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  setDueDate() {
    this.dateFilter = null;
    const start = moment(
      `${this.fromDate.day}/${this.fromDate.month}/${this.fromDate.year}`,
      'DD/MM/YYYY'
    );
    const end = moment(
      `${this.toDate.day}/${this.toDate.month}/${this.toDate.year}`,
      'DD/MM/YYYY'
    );

    if (start && end) {
      const rangeVal = `${start.format('DD-MMM-YYYY')} to ${end.format(
        'DD-MMM-YYYY'
      )}`;
      this.date.type = {
        value: { start: start, end: end },
        display: rangeVal,
        range: true,
      };
      this.startDate = `${start.format('YYYY-MM-DD')}`;
      this.endDate = `${end.format('YYYY-MM-DD')}`;
    }
    this.page = 1;
    this.search();
  }

  dateUpdated(filter) {
    this.dateFilter = filter;
    this.datePeriod();
  }

  datePeriod() {
    this.DATE_FILTERS.forEach((item) => {
      item.selectable = false;
    });

    if (this.dateFilter) {
      this.dateFilter.selectable = true;
    }

    let start = moment();
    let end = moment();

    if (this.dateFilter?.value === 'today') {
      start = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
    } else if (this.dateFilter?.value === 'yesterday') {
      const yesterday = moment().subtract(1, 'days');
      start = yesterday.clone();
      end = yesterday.clone();
    } else if (this.dateFilter?.value === 'cm' || this.dateFilter?.value === 'curr_month') {
      start = moment(`01/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
    } else if (this.dateFilter?.value === 'lm' || this.dateFilter?.value === 'last_month') {
      const lastMonth = moment().subtract(1, 'month');
      start = lastMonth.clone().startOf('month');
      end = lastMonth.clone().endOf('month');
    } else if (this.dateFilter?.value === 'last30') {
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      start = end.clone().subtract(30, 'days');
    } else {
      start = moment(`01/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
    }

    if (start && end) {
      const rangeVal = `${start.format('DD-MMM-YYYY')} to ${end.format(
        'DD-MMM-YYYY'
      )}`;
      this.date.type = {
        value: { start: start, end: end },
        display: this.dateFilter?.display || rangeVal,
        range: true,
      };
      this.startDate = `${start.format('YYYY-MM-DD')}`;
      this.endDate = `${end.format('YYYY-MM-DD')}`;
    }
    this.page = 1;

    this.search();
  }

  clearAbandonedCartSearch() {
    this.email = '';
    this.page = 1;
    this.search();
  }
  search() {
    console.log('Retrieving abandoned carts');
    this.getAbandonedCarts();
  }

  getOrderType(key: string) {
    if (key === 'membership') return ORDER_TYPE['MEMBERSHIP'];
    if (key === 'openapi') return ORDER_TYPE['OPEN_API'];
    if (key === 'fiv5s') return ORDER_TYPE['FIV5S'];
    return ORDER_TYPE['DEFAULT'];
  }

  get filteredCartHistoryList() {
    const selectedFilters = {};
    const filterTable = this.filterTable;

    Object.values(filterTable).forEach(({ filterName, filterCallback }) => {
      const value = this[filterName]?.value;
      if (value !== undefined && value !== 'ALL' && value !== '') {
        selectedFilters[filterName] = value;
      }
    });

    let filteredCartList = this.allCarts;

    if (Object.keys(selectedFilters).length === 0) {
      this.finalList = this.allCarts;
      return this.sliceRecord(this.allCarts);
    } else {
      Object.keys(selectedFilters).forEach((filterKey) => {
        const filterValue = selectedFilters[filterKey];
        const filterData = this.getFilterDataByName(filterKey);

        filteredCartList = filteredCartList.filter((item) =>
          filterData?.filterCallback(item, filterValue)
        );
      });
      this.finalList = filteredCartList;
      return this.sliceRecord(this.finalList);
    }
  }

  sliceRecord(data) {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end = this.end > data.length ? data.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    return data.slice(this.start, this.end);
  }

  export(type) {
    let param = {
      store_id: this.store_id,
      date: this.formattedDate,
      page: this.page,
      limit: 0,
      status: 0,
      email: this.email,
      type: type,
    };

    if (
      this.selectedPlatformType?.value !== undefined &&
      this.selectedPlatformType?.value !== 'ALL'
    )
      param['platform'] = this.selectedPlatformType.value;
    if (
      this.selectedOrderType?.value !== undefined &&
      this.selectedOrderType?.value !== 'ALL'
    ) {
      let typeId = this.orderTypeFilters.find(
        (filter) => filter.value === this.selectedOrderType.value
      );
      param['source'] = typeId.id;
    }
    if (
      this.selectedStatus?.value !== undefined &&
      this.selectedStatus?.value !== 'ALL'
    ) {
      let statusId = this.cartStatusFilters.find(
        (filter) => filter.value === this.selectedStatus.value
      );
      param['status'] = statusId.id;
    }
    this.svc.downloadRequest(this.bearer, '/cart/export', param);
  }

  updateStatus(status, data) {
    let info = {
      warning: 'Are you sure you want to mark this cart as resolved?',
      confirm: 'Confirm Resolve?',
      button: 'Resolve',
      success: 'Mark as resolved',
      style: 'success',
    };
    if (status !== 2) {
      info = {
        warning: 'Are you sure you want to mark this cart as discarded?',
        confirm: 'Confirm Discard?',
        button: 'Discard',
        success: 'Mark as discarded',
        style: 'danger',
      };
    }
    this.utils.msgBox.open({
      message: this.utils.translate(info.warning),
      title: this.utils.translate(info.confirm),
      icon: 'warning',
      buttonList: [
        {
          text: this.utils.translate('Cancel'),
        },
        {
          text: this.utils.translate(info.button),
          style: info.style,
          onClick: () => {
            let param = {
              store_id: this.store_id,
              cart_id: data.cart_id,
              status: status,
              hash_id: data.hash_id,
            };

            this.svc.updateCartStatus(param, this.bearer).subscribe(
              (res) => {
                this.utils.notify.showSuccess(info.success);
                this.search();
              },
              (error) => {
                if (
                  error['error']['status_code'] === 400 ||
                  error['error']['status_code'] === 'error'
                ) {
                  this.utils.notify.showError(error['message']);
                }
              }
            );
          },
        },
      ],
    });
  }

  getFilterDataByName(filterName) {
    return this.filterTable.find((filter) => filter?.filterName === filterName);
  }

  getPlatformType(key) {
    return PLATFORM[key?.toUpperCase()];
  }

  public getWindowType(): string {
    if (window.innerWidth >= 560 && window.innerWidth < 761) {
      return 'tablet';
    } else if (window.innerWidth >= 340 && window.innerWidth < 560) {
      return 'mobile';
    } else {
      return 'screen';
    }
  }

  openFilter(content) {
    this.modalService
      .open(content, {
        windowClass: 'modal-filter-container',
        ariaLabelledBy: 'modal-basic-title',
        backdropClass: 'modal-filter-backdrop',
        centered: true,
        animation: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // A cart's status as shown on its row and in its popup.
  getCartStatus(data: any): { label: string; class: string } {
    const id = String(data?.status_id ?? '');
    if (id === '0') return { label: 'Pending', class: 'badge-pending' };
    if (id === '2') return { label: 'Resolved', class: 'badge-paid' };
    if (id === '8') return { label: 'Discarded', class: 'badge-not-paid' };
    return { label: '', class: '' };
  }

  // Status tabs above the list (All / Pending / Resolved / Discarded), each
  // with how many carts it holds under the other active filters.
  private statusTabCache: { source: any[]; key: string; tabs: any[] } = {
    source: null,
    key: '',
    tabs: [],
  };

  get statusTabs(): { option: any; count: number }[] {
    const source = this.allCarts || [];
    const others = this.filterTable
      .filter(({ filterName }) => filterName !== 'selectedStatus')
      .map((filter) => ({ ...filter, value: this[filter.filterName]?.value }))
      .filter(({ value }) => value !== undefined && value !== 'ALL' && value !== '');
    const key = `${source.length}#${others.map(({ filterName, value }) => `${filterName}=${value}`).join('|')}`;
    if (source === this.statusTabCache.source && key === this.statusTabCache.key) {
      return this.statusTabCache.tabs;
    }
    const scoped = source.filter((cart) =>
      others.every(({ filterCallback, value }) => filterCallback(cart, value))
    );
    const statusFilter = this.getFilterDataByName('selectedStatus');
    const tabs = CART.map((option) => ({
      option,
      count:
        option.value === 'ALL'
          ? scoped.length
          : scoped.filter((cart) => statusFilter.filterCallback(cart, option.value)).length,
    }));
    this.statusTabCache = { source, key, tabs };
    return tabs;
  }

  isSelectedFilter(selected: any, option: any): boolean {
    return (selected?.value || 'ALL') === option?.value;
  }

  selectStatusTab(option: any) {
    this.selectedStatus = option;
    this.page = 1;
  }

  // "More filters" holds platform and source.
  showFilterGroup(options: any[], selected: any): boolean {
    return options?.length > 2 || (selected?.value && selected.value !== 'ALL');
  }

  get moreFilterCount(): number {
    return [this.selectedPlatformType, this.selectedOrderType].filter(
      (f) => f?.value !== undefined && f.value !== 'ALL' && f.value !== ''
    ).length;
  }

  clearMoreFilters() {
    this.selectedPlatformType = this.platformTypeFilters[0];
    this.selectedOrderType = this.orderTypeFilters[0];
    this.page = 1;
  }

  // Phones fold the toolbar filters behind a "Filters" button next to the
  // search; its count says how many of them are narrowing the list.
  toolbarOpen = false;

  get toolbarFilterCount(): number {
    const dateChanged = this.dateFilter?.value !== 'cm' || (this.fromDate && this.toDate);
    return (dateChanged ? 1 : 0) + this.moreFilterCount;
  }

  // Rows show a page of the filtered list; the popup reads the cart by its
  // position in the full list.
  openCart(content: any, data: any) {
    this.openModal(content, this.allCarts.indexOf(data));
  }

  // A click anywhere on a row opens the cart, unless text was being selected.
  openCartFromRow(content: any, data: any) {
    if (window.getSelection()?.toString()) return;
    this.openCart(content, data);
  }
}
